/* eslint-disable react-hooks/exhaustive-deps */
import {faPlus, faTrash} from '@fortawesome/pro-solid-svg-icons';
import {Checkbox, FormControlLabel, Grid, IconButton, makeStyles, useTheme} from '@material-ui/core';
import {AutoCompleteWithLabel} from 'commons/AutoComplete/AutoCompleteWithLabel';
import {CustomButton} from 'commons/Button/CustomButton';
import {DialogType} from 'commons/Dialog/CustomDialog';
import CustomIcon from 'commons/Icon/CustomIcon';
import {localize} from 'commons/LocalizedText/LocalizedText';
import {ResponsibilitiesTable} from 'commons/Table/ResponsibilitiesTable';
import {useDialog} from 'hook/DialogProvider';
import React, {useEffect, useState} from 'react';
import {generateRow} from 'utils/helpers/RowHelper';

const useStyles = makeStyles((theme) => ({
  userPicker: {
    minWidth: 300,
    margin: theme.spacing(1),
    flexGrow: 1
  },
  checkboxPrimary: {
    color: theme.palette.primary.dark
  },
  checkboxSecondary: {
    color: theme.palette.primary.main
  },
  tableContainer: {
    maxWidth: '100%',
    overflowX: 'scroll'
  }
}));

export const Responsibilities = ({
  usersWithResponsibilities,
  setUsersWithResponsibilities,
  setResponsibilitiesHasChanges,
  programs,
  isLoadingUsersWithResponsibilities,
  isLoadingPrograms,
  isLoadingLaboUsers,
  laboUsers
}) => {
  const classes = useStyles();
  const showDialog = useDialog();
  const theme = useTheme();
  const [headers, setHeaders] = useState([]);
  const [userToAdd, setUserToAdd] = useState(null);
  const [laboUserOptions, setLaboUserOptions] = useState(laboUsers);

  useEffect(() => {
    setLaboUserOptions(laboUsers.filter(laboUser => !usersWithResponsibilities.map(userWithResp=> userWithResp.recid).includes(laboUser.recid)))
  },[laboUsers, usersWithResponsibilities])

  const replaceUserWithResponsibilities = (oldUser, newUser) => {
    const newUsersWithResponsibilities = [...usersWithResponsibilities];
    let oldUserIndex;
    newUsersWithResponsibilities.forEach((r, index) => {
      if(r.recid === oldUser.recid){
        oldUserIndex = index;
      }
    });
    if(!newUser){
      showDialog({
        variant: DialogType.CONFIRMATION,
        title: 'deletion',
        description: 'deletionConfirmMessage',
        onSubmit: () => handleDeleteUser(newUsersWithResponsibilities, oldUser, oldUserIndex)
      });
    }else{
      newUsersWithResponsibilities.splice(oldUserIndex, 1, newUser);
      setUsersWithResponsibilities(newUsersWithResponsibilities);
    }
  }

  const handleDeleteUser = (newUsersWithResponsibilities, user, index) => {
    const newUser = {...user, deleted: true};
    newUser.programResponsibilities.forEach(programResponsibilitie => programResponsibilitie.programs = []);
    newUsersWithResponsibilities.splice(index, 1, newUser);
    setUsersWithResponsibilities(newUsersWithResponsibilities);
  }

  const handleCheckResponsibility = (userWithResponsibilities, responsibility, program) => {
    setResponsibilitiesHasChanges(true);
    let newUserWithResponsibilities = Object.assign({}, userWithResponsibilities);
    if(userWithResponsibilities.programResponsibilities.find(resp =>
      resp.responsibility === responsibility)?.programs.find(prog => prog.recid === program.recid))
    {
      newUserWithResponsibilities.programResponsibilities.find(resp => resp.responsibility === responsibility).programs =
      newUserWithResponsibilities.programResponsibilities.find(resp =>
        resp.responsibility === responsibility
      )?.programs.filter(prog => prog.recid !== program.recid)
    }else{
      newUserWithResponsibilities.programResponsibilities.find(resp => resp.responsibility === responsibility)?.programs.push(program);
    }
    replaceUserWithResponsibilities(userWithResponsibilities, newUserWithResponsibilities);
  }

  const handleCheckAllResponsibilities = (userWithResponsibilities, responsibility) => {
    setResponsibilitiesHasChanges(true);
    let newUserWithResponsibilities = Object.assign({}, userWithResponsibilities);
    if(userWithResponsibilities.programResponsibilities.find(resp => resp.responsibility === responsibility)?.programs.length !== programs.length){
      newUserWithResponsibilities.programResponsibilities.find(resp => resp.responsibility === responsibility).programs = [...programs];
    }else{
      newUserWithResponsibilities.programResponsibilities.find(resp => resp.responsibility === responsibility).programs = [];
    }
    replaceUserWithResponsibilities(userWithResponsibilities, newUserWithResponsibilities);
  }

  const addResponsibilitiesToUser = user => {
    const tmpArray = Array.from(usersWithResponsibilities);
    tmpArray.push({
      firstName: user.firstName,
      name: user.lastName,
      programResponsibilities: [
        {responsibility: 'Accounting', programs: []},
        {responsibility: 'Administrative', programs: []},
        {responsibility: 'Technique', programs: []}
      ],
      recid: user.recid
    });
    setUsersWithResponsibilities(tmpArray);
    setUserToAdd(null);
  }

  useEffect(() =>{
    if(!isLoadingPrograms)
      setHeaders(
        [
          generateRow({
            name: 'User',
            width: '10%',
            isSortable: false,
            bold: true,
            template: (row) => (
              <div>
                {`${row.firstName} ${row.name}`}
              </div>
            )
          }),
          generateRow({
            name: 'Role',
            displayInfo: true,
            infoText: (
              <>
                {localize('explainRolePart1')}
                <br/>
                <br/>
                - <strong>{localize('accountingExplainRolePart1')}</strong>{localize('accountingExplainRolePart2')}
                <br/>
                - <strong>{localize('techniqueExplainRolePart1')}</strong>{localize('techniqueExplainRolePart2')}
                <br/>
                - <strong>{localize('administrativeExplainRolePart1')}</strong>{localize('administrativeExplainRolePart2')}
                <br/>
                <br/>
                <strong>{localize('exampleExplainRolePart1')}</strong>{localize('exampleExplainRolePart2')}
              </>
            ),
            width: '10%',
            isSortable: false,
            template: (row) => (
              <Grid container direction='column' spacing={2}>
                {row.programResponsibilities.map(responsibility => <Grid item>{responsibility.responsibility}</Grid>)}
              </Grid>
            )
          }),
          generateRow({
            name: 'All',
            displayInfo: true,
            infoText: 'responsibilitiesAllTooltip',
            width: '10%',
            isSortable: false,
            template: (row) => (
              <Grid container direction='column'>
                {row.programResponsibilities.map(responsibility =>
                  <Grid item>
                    {
                      <FormControlLabel
                        control={(
                          <Checkbox
                            checked={responsibility.programs.length === programs.length}
                            className={classes.checkboxPrimary}
                            color="default"
                            onChange={() => handleCheckAllResponsibilities(row, responsibility.responsibility)}
                          />
                        )}
                      />
                    }
                  </Grid>
                )}
              </Grid>
            )
          }),
          ...programs.map(program => {
            return generateRow({
              name: program.text,
              width: '5%',
              template: (row) => (
                <Grid container direction='column'>
                  {row.programResponsibilities.map(responsibility =>
                    <Grid item>
                      {
                        <FormControlLabel
                          control={(
                            <Checkbox
                              checked={responsibility.programs.find(p => p.recid === program.recid) !== undefined}
                              className={classes.checkboxSecondary}
                              color="default"
                              onChange={() => handleCheckResponsibility(row, responsibility.responsibility, program)}
                            />
                          )}
                        />
                      }
                    </Grid>
                  )}
                </Grid>
              )
            });
          }),
          generateRow({
            align: 'center',
            name: 'Actions',
            width: '5%',
            isSortable: false,
            template: (row) => (
              <div>
                <IconButton
                  onClick={() => {replaceUserWithResponsibilities(row)}}
                >
                  <CustomIcon icon={faTrash} style={{color: theme.palette.error.main}}/>
                </IconButton>
              </div>
            )
          })
        ]);
  }, [programs, usersWithResponsibilities])

  return (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <Grid alignItems='center' container justifyContent='center'>
          <Grid item xs={8}>
            <AutoCompleteWithLabel
              className={classes.userPicker}
              getOptionLabel={(option) => `${option.firstName} ${option.lastName}`}
              label="addResponsibilitiesToUser"
              loading={isLoadingLaboUsers}
              loadingText={localize('loadingText')}
              noOptionsText={localize('noOptionsText')}
              onChange={value => {
                if (value) {
                  setUserToAdd(value);
                }
              }}
              options={laboUserOptions}
              textFieldLabel="userName"
              value={userToAdd}
            />
          </Grid>
          <Grid item>
            <CustomButton
              className={classes.margin}
              onClick={async () => {
                if (userToAdd) {
                  addResponsibilitiesToUser(userToAdd);
                }
              }}
            >
              <CustomIcon icon={faPlus} />
              <span>&nbsp;</span>{localize('addResponsibilities')}
            </CustomButton>
          </Grid>
        </Grid>
      </Grid>
      <Grid classes={{root: classes.tableContainer}} item>
        <ResponsibilitiesTable
          headers={headers}
          isLoading={isLoadingUsersWithResponsibilities || isLoadingPrograms}
          rowKey="userResponsibility"
          rows={usersWithResponsibilities.filter(user => !user.deleted)}
        />
      </Grid>
    </Grid>
  );
};